import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { DataGrid } from '@mui/x-data-grid';
import { getSubsidiariesList } from './services/subsidiariesApi';
import { useSelector } from 'react-redux';
import { ORGANIZATION_SUBSIDARIES_LIST_URL } from '../../../../../constants';
import { DataGridContainer } from '../../../../ui/styled';
import { renderCellExpand } from '../../../../common/GridCell/GridCellExpand';

const Subsidiaries = () => {
  const [user, setUser] = useState(null);
  const [subsidiariesList, setSubsidiariesList] = useState({
    isLoading: false,
    data: [],
    total: 0,
    // page: 1,
    // pageSize: 10,
    // sortModel: '',
  });
  const organizationForm = useSelector((state) => state.organizationForm);
  const { newOrganizationForm, orgId } = organizationForm;

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken && !newOrganizationForm) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const fetchData = async () => {
    setSubsidiariesList((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${ORGANIZATION_SUBSIDARIES_LIST_URL}/${orgId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const subsidiaries = await getSubsidiariesList({
      commonParams,
      authorization,
    });
    setSubsidiariesList((prveState) => ({
      ...prveState,
      ...subsidiaries,
    }));
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const columnsData = [
    {
      field: 'orgKey',
      headerName: 'Organization Key',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'orgId',
      headerName: 'Org Id',
      minWidth: 50,
    },
    {
      field: 'address',
      headerName: 'Address',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'city',
      headerName: 'City',
      renderCell: renderCellExpand,
      minWidth: 80,
    },
    { field: 'county', headerName: 'County', minWidth: 50 },
    { field: 'countyName', headerName: 'County Name', minWidth: 120 },
    {
      field: 'phone',
      headerName: 'Phone',
      renderCell: renderCellExpand,
      flex: 1,
    },
  ];
  return (
    <DataGridContainer>
      <DataGrid
        getRowHeight={() => 'auto'}
        columns={columnsData}
        rows={subsidiariesList.data}
        // pageSize={contactList.pageSize}
        // page={contactList.page - 1}
        rowCount={subsidiariesList.total}
        // paginationMode='server'
        // sortingMode='server'
        // onPageSizeChange={(newPageSize) =>
        //   setContactList((old) => ({ ...old, pageSize: newPageSize }))
        // }
        // onPageChange={(newPage) => {
        //   setContactList((old) => ({ ...old, page: newPage + 1 }));
        // }}
        // rowsPerPageOptions={paginationSize}
        //pagination
        //components={{ Toolbar: QuickSearchToolbar }}
        experimentalFeatures={{ newEditingApi: true }}
        //onSortModelChange={handleSortModelChange}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        loading={subsidiariesList.isLoading}
      />
    </DataGridContainer>
  );
};

export default Subsidiaries;
